import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface ModalConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'confirm' | 'alert' | 'prompt';
  inputValue?: string;
  inputPlaceholder?: string;
  danger?: boolean;
}

export interface ModalResult {
  confirmed: boolean;
  value?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<{ config: ModalConfig; callback: (result: ModalResult) => void }>();
  public modal$ = this.modalSubject.asObservable();

  confirm(title: string, message: string, confirmText: string = 'Confirm', cancelText: string = 'Cancel', danger: boolean = false): Observable<boolean> {
    return new Observable(observer => {
      const config: ModalConfig = {
        title,
        message,
        confirmText,
        cancelText,
        type: 'confirm',
        danger
      };

      this.modalSubject.next({
        config,
        callback: (result: ModalResult) => {
          observer.next(result.confirmed);
          observer.complete();
        }
      });
    });
  }

  alert(title: string, message: string, confirmText: string = 'OK'): Observable<boolean> {
    return new Observable(observer => {
      const config: ModalConfig = {
        title,
        message,
        confirmText,
        type: 'alert'
      };

      this.modalSubject.next({
        config,
        callback: (result: ModalResult) => {
          observer.next(true);
          observer.complete();
        }
      });
    });
  }

  prompt(title: string, message: string, inputPlaceholder: string = '', initialValue: string = '', confirmText: string = 'Submit', cancelText: string = 'Cancel'): Observable<string | null> {
    return new Observable(observer => {
      const config: ModalConfig = {
        title,
        message,
        confirmText,
        cancelText,
        type: 'prompt',
        inputValue: initialValue,
        inputPlaceholder
      };

      this.modalSubject.next({
        config,
        callback: (result: ModalResult) => {
          observer.next(result.confirmed ? result.value || '' : null);
          observer.complete();
        }
      });
    });
  }
}
